import { MULTI_SELECT_CF_TYPE } from '@atlassian/jira-platform-field-config';
import type { StringValue, RichValue } from '../../../value/types';
import type { TransformedMultiSelectField, TransformedMultiSelectOption } from '../types';

const getMultiSelectStringValue: StringValue<TransformedMultiSelectField> = (field) =>
	String(field.value?.map((option) => option?.value ?? '').join(', ') ?? '');

export const multiSelectStringValueHandler = {
	[MULTI_SELECT_CF_TYPE]: getMultiSelectStringValue,
};

const getMultiSelectRichValue: RichValue<
	TransformedMultiSelectField,
	TransformedMultiSelectOption[]
> = (field) => field.value ?? [];

export const multiSelectRichValueHandler = {
	[MULTI_SELECT_CF_TYPE]: getMultiSelectRichValue,
};
